/* eslint-disable react/jsx-pascal-case */
import { Chip, IconButton, Tooltip } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import BackspaceIcon from "@material-ui/icons/Backspace";
import moment from "moment";
import React from "react";
import { API_URL } from "../../../constants/api";
import { SECTIONS, standardDateFormat } from "../../../constants/appConstants";
import { apiRequest } from "../../../utils/api_service";
import { IsSectionVisible, kpiRadioSlider } from "../../../utils/helper";
import { ShowToast, toastType } from "../../../utils/toast-service";
import DatacenterList from "../../common/DatacenterList/DatacenterList";
import SliderDatePicker from "../../common/SliderDatePicker/SliderDatePicker";
import HealthAndSeftyGrphChart from "../HealthAndSefty/HealthAndSeftyGrphChart";
import APM from "./APM/Apm";
import "./Maintenance.less";
import MaintenanceStatusWidget from "./MaintenanceCompletedWidget";
import MaintenanceInProgressWidget from "./MaintenanceInProgressWidget";
import MaintenanceNotCompletedWidget from "./MaintenanceNotCompletedWidget";
import NotificationsSentWidget from "./NotificationsSentWidget";
import SeverityIssuesTable from "./SeverityIssuesTable";

class Maintenance extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      datacenterList: undefined,
      selectedPropertyIdSingle: localStorage.getItem("selectedPropertyId"),
      selectedPropertyId: localStorage.getItem("selectedPropertyIdMultiple"),
      selectedDatacenterNames:
        localStorage.getItem("selectedPropertyIdMultipleNames") != null
          ? localStorage.getItem("selectedPropertyIdMultipleNames").split(",")
          : [],
      startDate: moment(localStorage.getItem("selectedendDate"))
        .startOf("month")
        .format("L"),
      endDate: moment(localStorage.getItem("selectedendDate"))
        .endOf("month")
        .format("L"),
      view: "maintenance",
      selectedPropertyAbbr:
        (localStorage.getItem("Abbreviation") || "").split(",") || [],
      isChangedDC: false
    };
  }

  componentDidMount() {
    if (this.state.datacenterList == undefined) {
      this.getDataCenterList();
    }

    const endOfMonth = moment()
      .endOf("month")
      .format("L");

    if (moment(endOfMonth) > moment(this.state.endDate)) { /* empty */ } else {
      const startDate = moment()
        .startOf("month")
        .format("L");
      const endDate = moment()
        .endOf("month")
        .format("L");

      localStorage.setItem("selectedstartDate", startDate);
      localStorage.setItem("selectedendDate", endDate);
      localStorage.setItem("MTDDefault", moment().format("MM"));
      this.setState({ startDate: startDate, endDate: endDate });
    }
  }

  /** Datacenter list */
  getDataCenterList = () => {
    apiRequest({ url: API_URL.datacenter.getDatacenterList }).then(
      datacenterList => {
        this.setState({
          datacenterList: datacenterList.data
        });
      }
    );
  };

  /** property selection */
  onPropertySelect = (id, selectedDatacenterNames, abbr) => {
    const idList = id.toString();

    if (selectedDatacenterNames == undefined && abbr == undefined) {
      localStorage.setItem("selectedPropertyIdSingle", id);
      this.setState({
        selectedPropertyIdSingle: id
      });
    } else {
      localStorage.setItem("selectedPropertyIdMultiple", id);
      this.setState({
        selectedPropertyId: idList,
        selectedDatacenterNames: selectedDatacenterNames,
        selectedPropertyAbbr: abbr
      });
    }
  };

  /** text field change call */
  _handleTextFieldChange = e => {
    const input = e;
    const output = moment(input, "YYYY-MM");
    localStorage.setItem(
      "selectedstartDate",
      output.startOf("month").format("L")
    );
    localStorage.setItem("selectedendDate", output.endOf("month").format("L"));
    this.setState({
      startDate: output.startOf("month").format("L"),
      endDate: output.endOf("month").format("L"),
    });
  };

  /** call on date change */
  handelDateChangesSlideDate = (start, end, typeOfDate) => {
    this.setState({ startDate: start, endDate: end, typeOfDate: typeOfDate });
  };

  /** Abbrevation delete call */
  abbreviationHandleDelete = value => {
    const {selectedPropertyId, selectedDatacenterNames,selectedPropertyAbbr, isChangedDC } = this.state;
    let propertyIDToRemove = (selectedPropertyId || "" ).split(",");
    if (propertyIDToRemove.length == 1) {
      ShowToast(
        "You cannot deselect all the Data Centers.",
        toastType.WARNING,
        5000,
        null
      );
      return false;
    }
    let propertyNameToRemove =selectedDatacenterNames;
    let propertyAbToRemove = selectedPropertyAbbr;
    const obj = this.state.datacenterList.find(o => o.abbreviation === value);

    propertyIDToRemove = propertyIDToRemove.filter(function (item) {
      return item != obj.propertyID;
    });

    propertyNameToRemove = propertyNameToRemove.filter(function (item) {
      return item !== obj.name;
    });

    propertyAbToRemove = propertyAbToRemove.filter(function (item) {
      return item !== value;
    });

    localStorage.setItem(
      "selectedPropertyIdMultiple",
      propertyIDToRemove.toString()
    );
    localStorage.setItem(
      "selectedPropertyIdMultipleNames",
      propertyNameToRemove.toString()
    );
    localStorage.setItem("Abbreviation", propertyAbToRemove.toString());
    this.setState({
      selectedPropertyId: propertyIDToRemove.join(","),
      selectedDatacenterNames: propertyNameToRemove,
      selectedPropertyAbbr: propertyAbToRemove,
      isChangedDC: !isChangedDC
    });
  };

  render() {
    const SeverityIssuesTableVisible =
      IsSectionVisible(
        SECTIONS.MAINTENANCE,
        SECTIONS.LIST_OF_OPEN_HIGH_SEVERITY_ISSUES
      ) ||
      IsSectionVisible(
        SECTIONS.MAINTENANCE,
        SECTIONS.LIST_OF_OPEN_LOW_SEVERITY_ISSUES
      ) ||
      IsSectionVisible(
        SECTIONS.MAINTENANCE,
        SECTIONS.LIST_OF_OPEN_MEDIUM_SEVERITY_ISSUES
      );
    const OperationalIncidents = IsSectionVisible(
      SECTIONS.MAINTENANCE,
      SECTIONS.OPERATIONAL_INCIDENTS
    );
    // const ViewAPM = IsSectionVisible(
    //   SECTIONS.MAINTENANCE,
    //   SECTIONS.VIEW_APM_BUTTON
    // );
    return (
      <Grid container>
        <Grid item xs={12}>
          <Grid container className={"reports-row-one"}>
            <Grid item xs={12} sm={4} lg={4}>
              <Box className={"w-25 reports-dclist"}>
                {this.state.view == "maintenance" ? (
                  <DatacenterList
                    dataSource={this.state.datacenterList}
                    onPropertySelect={this.onPropertySelect}
                    classTitle={"dc-list-reports"}
                    selectedPropertyId={this.state.selectedPropertyId}
                    SeType={"MultipleMaterial"}
                    isChangedDC={this.state.isChangedDC}
                  />
                ) : (
                  <DatacenterList
                    dataSource={this.state.datacenterList}
                    onPropertySelect={this.onPropertySelect}
                    classTitle={"dc-list-reports"}
                    selectedPropertyId={this.state.selectedPropertyIdSingle}
                  />
                )}
                <br /> <br />
                {/* hide View APM button till Event Calendar functionality get completed */}
                {/* {this.state.view == "maintenance" && ViewAPM && false ? (
                  <Tooltip title={"View APM"}>
                    <Button
                      variant={"contained"}
                      size={"small"}
                      style={{ marginRight: "10px", width: "140px" }}
                      onClick={() => this.setState({ view: "APM" })}
                      aria-label={"close"}
                      startIcon={
                        <EventAvailableIcon
                          fontSize={"inherit"}
                          style={{ color: "var(--common--Text--color)" }}
                        />
                      }
                    >
                      {"View APM\r"}
                    </Button>
                  </Tooltip>
                ) : null} */}
              </Box>
            </Grid>
            <Grid item xs={12} sm={1} lg={1}>
              {" "}
            </Grid>
            <Grid item xs={12} sm={7} lg={7} justifyContent={"flex-end"}>
              <Box className={"reports-datepicker"}>
                {this.state.view == "maintenance" ? (
                  <>
                    <SliderDatePicker
                      handelDateChangesSlideDate={
                        this.handelDateChangesSlideDate
                      }
                      selectedDate={moment().format(standardDateFormat)}
                      radioSlider={kpiRadioSlider}
                      isAll
                    />
                  </>
                ) : (
                  <Tooltip title={"Back To Maintenance"}>
                    <IconButton
                      onClick={() => this.setState({ view: "maintenance" })}
                      aria-label={"close"}
                      size={"small"}
                    >
                      <BackspaceIcon size={"small"} />
                    </IconButton>
                  </Tooltip>
                )}
              </Box>
            </Grid>
          </Grid>
        </Grid>
        {this.state.view == "maintenance" ? (
          <Grid xs={12} className={"dataCenter-list-div common-colour"}>
            <b>{"Selected Data Centers:"}</b>{" "}
            {this.state.selectedPropertyAbbr.map(value => (
              <Chip
                label={value}
                onDelete={() => this.abbreviationHandleDelete(value)}
                variant={"outlined"}
                style={{ marginLeft: "4px" }}
                className={"common-colour"}
              />
            ))}
          </Grid>
        ) : null}
        {this.state.view == "maintenance" ? (
          <>
            <Grid item xs={12}>
              <Grid container>
                {IsSectionVisible(
                  SECTIONS.MAINTENANCE,
                  SECTIONS.MAINTENANCE_COMPLETED
                ) && (
                    <Grid item xs={12} sm={4}>
                      <Box mr={1}>
                        <MaintenanceStatusWidget
                          propertyId={this.state.selectedPropertyId}
                          endDate={this.state.endDate}
                          startDate={this.state.startDate}
                        />
                      </Box>
                    </Grid>
                  )}
                {IsSectionVisible(
                  SECTIONS.MAINTENANCE,
                  SECTIONS.MAINTENANCE_NOT_COMPLETED
                ) && (
                    <Grid item xs={12} sm={4}>
                      <Box mr={1}>
                        <MaintenanceNotCompletedWidget
                          propertyId={this.state.selectedPropertyId}
                          endDate={this.state.endDate}
                          startDate={this.state.startDate}
                        />
                      </Box>
                    </Grid>
                  )}
                {IsSectionVisible(
                  SECTIONS.MAINTENANCE,
                  SECTIONS.MAINTENANCE_IN_PROGRESS
                ) && (
                    <Grid item xs={12} sm={4}>
                      <Box  >
                        <MaintenanceInProgressWidget
                          propertyId={this.state.selectedPropertyId}
                        />
                      </Box>
                    </Grid>
                  )}

              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={7} lg={7} >
              <Grid container>

                {SeverityIssuesTableVisible && (
                  <Grid item xs={12} md={12}>
                    <Box className={"Severity-table-maintenance"} mt={1}>
                      <SeverityIssuesTable
                        propertyId={this.state.selectedPropertyId}
                        endDate={this.state.endDate}
                        startDate={this.state.startDate}
                        type={"High"}
                      />
                    </Box>
                  </Grid>
                )}

              </Grid>
            </Grid>
            <Grid item xs={12} lg={SeverityIssuesTableVisible ? 5 : 12}>
              <Grid container>
                {IsSectionVisible(
                  SECTIONS.MAINTENANCE,
                  SECTIONS.INCIDENT_OPEN_ISSUES
                ) && (
                    <Grid Grid xs={12} lg={SeverityIssuesTableVisible ? 12 : 5} sm={12} md={SeverityIssuesTableVisible ? 12 : 5}>
                      <Box mt={1}>
                        <NotificationsSentWidget
                          propertyId={this.state.selectedPropertyId}
                          endDate={this.state.endDate}
                          startDate={this.state.startDate}
                        />
                      </Box>
                    </Grid>
                  )}
                {OperationalIncidents && (
                  <Grid item xs={12} lg={SeverityIssuesTableVisible ? 12 : 5} md={SeverityIssuesTableVisible ? 12 : 5}>
                    <Box mt={1}>
                      <div className={"graph-div-report"}>
                        <HealthAndSeftyGrphChart
                          conf={1}
                          reference={"HealthandSeaftyBarChart"}
                          propertyId={this.state.selectedPropertyId}
                          endDate={this.state.endDate}
                          startDate={this.state.startDate}
                          typeOfDate={this.state.typeOfDate}
                        />
                      </div>
                    </Box>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </>
        ) : (
          <>
            <Grid item xs={12}>
              <APM
                propertyId={this.state.selectedPropertyIdSingle}
                endDate={this.state.endDate}
                startDate={this.state.startDate}
              />
            </Grid>
          </>
        )}
      </Grid>
    );
  }
}

export default Maintenance;
